/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useContext } from 'react';
import { object, number, bool } from 'prop-types';

// MUI
import { Grid, Divider } from '@material-ui/core';

// Helpers
import { getAddressTypeNickName } from '../../Helpers/Helpers';
import { formatPhoneNumber } from '../../../../../../utils/formater';
import { RecipientBookContext } from '../../Context/RecipientBookContext';

// Components
import EditMailingAddress from './EditMailingAddress';
import { useDispatch } from 'react-redux';
import { trackEvent } from '../../../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

// Icons
import closeIcon from '../../Assets/filterCloseIcon.svg';

const AddressCard = ({
    classes, address, index, isParentDesktopComponent
}) => {
    const isCountryUSAorCanada = ['US', 'USA', 'CA', 'CAN', 'United States', 'Canada'].includes(address.country);
    if (!isCountryUSAorCanada) {
        return null;
    }
    const dispatch = useDispatch();

    const { recipientState, setRecipientState, setCurrentRecipient, isAddressEditing, setIsOccasionsEditing, setIsAddressEditing,
        setIsProfileEditing,  selectedAddressToEdit, setSelectedAddressToEdit, setSelectedOccasionToEdit, setShowMoreOccasions,
    } = useContext(RecipientBookContext);
    const addressBookEntryId = address?.addressBookEntryId;
    const shouldDisplayAddress = address.city && address.state && address.zip;
    const isDefaultAddress = address?.defaultKey === '1';

    const handleEditAddress = () => {
        dispatch(trackEvent({
            eventName: "contact_edit_interaction",
            edit_action_type: "Edit Address",
            eventCategory: "Address Book",
            eventAction: "Contact Edit",
            eventLabel: "Address Edit"          
        }))
        setSelectedAddressToEdit(address); // setting to close editadrress screen
        setIsProfileEditing(false); // setting global profile state true to keep edit profile form open
        setIsOccasionsEditing(false); // setting global occasion state true to keep edit occasion form open
        setSelectedOccasionToEdit('');
        setIsAddressEditing(true);
        setShowMoreOccasions(false);
    };
    
    return (
        <>
            <Grid container item xs={12} key={addressBookEntryId} className={classes.addMailingAddress}>
                {selectedAddressToEdit.addressBookEntryId !== address.addressBookEntryId && shouldDisplayAddress && (
                    <>
                        <Grid container item xs={10} className="addressList" direction="row" style={{ margin: '16px 0 16px 0' }}>
                            <Grid item xs={12} className='addressNickname'>{getAddressTypeNickName(address?.addressType)}</Grid>
                            <Grid item xs={12} className='addressDetails'>{address?.employerName || ''}</Grid>
                            <Grid item xs={12} className='addressDetails'>{address?.addressLineOne}, {address?.addressLineTwo}</Grid>
                            <Grid item xs={12} className='addressDetails'>{address?.city}, {address?.state}, {address?.zip}</Grid>
                            <Grid item xs={12} className='addressDetails'>{formatPhoneNumber(address?.phoneNumber || '')}</Grid>
                        </Grid>
                        <Grid item xs={2} container direction="row" justifyContent="flex-end" alignItems="flex-start" style={{ margin: '16px 0 16px 0' }}>
                            <button type="button" style={{ borderRadius: '0px', cursor: 'pointer' }} className={classes.editBtn} onClick={handleEditAddress}>Edit</button>
                        </Grid>
                    </>
                )}
                {isAddressEditing && (address.addressBookEntryId === selectedAddressToEdit.addressBookEntryId) && (
                    <Grid item xs={12} key={addressBookEntryId}>
                        <Grid container item xs={12} direction="row">
                            <Grid item xs={10} className='addressNickname'>{getAddressTypeNickName(address?.addressType)}{isDefaultAddress ? <span> - default</span> : ''}</Grid>
                            <Grid container item xs={2} style={{ justifyContent: 'end'}}>
                                <div className={classes.closeIcon} role="button" tabIndex={0} onClick={() => { setIsAddressEditing(false); setSelectedAddressToEdit('') }} onKeyDown={() => { }}><span><img src={closeIcon} alt="close icon" /></span></div>
                            </Grid>
                        </Grid>
                        <EditMailingAddress
                            setIsAddressEditing={setIsAddressEditing}
                            setSelectedAddressToEdit={setSelectedAddressToEdit}
                            classes={classes}
                            address={address}
                            recipientState={recipientState}
                            setRecipientState={setRecipientState}
                            setCurrentRecipient={setCurrentRecipient}
                            isParentDesktopComponent={isParentDesktopComponent}
                        />
                    </Grid>
                )}
            </Grid>
            <Divider style={{ margin: '10px 0 10px 0' }} />
        </>
    );
};

AddressCard.propTypes = {
    index: number.isRequired,
    address: object.isRequired,
    classes: object.isRequired,
    isParentDesktopComponent: bool.isRequired,
};

export default AddressCard;
